import { useEffect, useContext } from 'react'
import { fetchTourDeal } from 'actions/tour/TourV2Actions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import GeoContext from 'contexts/geoContext'

type ReturnType = [
  App.Tours.TourDeal | undefined,
  boolean
]

export function useTourDeal(slug: string | undefined): ReturnType {
  const dispatch = useAppDispatch()
  const deal = useAppSelector((state) => state.tour.tourDeals[slug ?? ''])
  const fetchingDeal = useAppSelector((state) => state.tour.fetchingTourDealBySlugAndFacets[slug ?? ''])
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    if (slug) {
      dispatch(fetchTourDeal(slug, currentRegionCode.toUpperCase()))
    }
  }, [slug, dispatch, currentRegionCode])

  return [
    deal,
    fetchingDeal,
  ]
}
